import React, { useState, useEffect } from 'react';
import { Select, MenuItem, TextField, Checkbox, Button } from '@mui/material';
import connect from "react-redux/es/components/connect";
import translate from "../i18n/translate";
import { actionToggleFooter, actionToggleNavBar, actionToggleSideBar } from "../store/action/LayoutActionSupervisor";
import { client, actionGetSupervisorAccessRights, getAccessRightsForPageID, actionGetSupervisorListForAccessRights } from "../store/action/RemoteActionSupervisor";
import { getMultiLanguageMessage } from "../i18n/multiLanguage";
import { PAGELABEL, ACCESSRIGHTS, PAGEID, ACCESSRIGHTSTYPE } from "../i18n/constants";
import { resetTimout } from "./common/FirebaseSupervisor";

let BASE_URL = process.env.REACT_APP_SERVER_URL_API;

const SupervisorAccessRights = (props) => {
    const [language, setLanguage] = useState("");
    const [pageAccessRights, setPageAccessRights] = useState({});
    const [searchField, setSearchField] = useState(0);
    const [searchKeyword, setSearchKeyword] = useState('');
    const [supervisorList, setSupervisorList] = useState([]);
    const [selectedAdmin, setSelectedAdmin] = useState({});
    const [supervisorAccessRights, setAdminAccessRights] = useState([]);
    const [isReadAllAccess, setIsReadAllAccess] = useState(false);
    const [isWriteAllAccess, setIsWriteAllAccess] = useState(false);
    const [isDeleteAllAccess, setIsDeleteAllAccess] = useState(false);
    const [isImportAllAccess, setIsImportAllAccess] = useState(false);
    const [isExportAllAccess, setIsExportAllAccess] = useState(false);
    const [isVerifyAllAccess, setIsVerifyAllAccess] = useState(false);
    const [isApproveAllAccess, setIsApproveAllAccess] = useState(false);
    const [isButtonClicked, setIsButtonClicked] = useState(false);
    const [isSubmitSuccess, setIsSubmitSuccess] = useState(false);
    const [changeStatus, setChangeStatus] = useState(false); //Trigger page rendering
    const [pageId, setPageId] = useState(0);

    const onClickSearch = () => {
        resetTimout();
        const requestBody = {
            SearchField: searchField,
            SearchKeyword: searchKeyword
        };
        setIsButtonClicked(true);
        props.actionGetSupervisorListForAccessRights(requestBody);
        setSupervisorList([]);
        setPageId(0);
    };

    const onClickClear = () => {
        resetTimout();
        setSupervisorList([]);
        setSearchField(0);
        setSearchKeyword('');
        setSelectedAdmin({});
        setAdminAccessRights([]);
        setPageId(0);
    };

    const handleChange = (e) => {
        resetTimout();
        let eventValue = e.target.value;
        switch (e.target.name) {
            case "search-field":
                eventValue = parseInt(eventValue);
                setSearchField(eventValue);
                if (eventValue === 0) {
                    setSearchKeyword("");
                }
                break;
            case "search-keyword":
                setSearchKeyword(eventValue);
                break;
            default:
                console.log(e.target.name);
        }
    };

    const goToAdminAcessRights = async (index) => {
        setSelectedAdmin(supervisorList[index]);
        setPageId(1);
        setAdminAccessRights([]);
        setIsButtonClicked(true);
        props.actionGetSupervisorAccessRights({ SearchAdminID: supervisorList[index].AdminID });
    };

    const handleAccessRightsChange = (e, index, accessRightType) => {
        if (index < 0 || supervisorAccessRights.length <= index || !e) return;

        let nAccessRight = e.target.checked ? 2 : 1;
        if (accessRightType === ACCESSRIGHTS.Read) {
            supervisorAccessRights[index].ReadAccess = nAccessRight;
        } else if (accessRightType === ACCESSRIGHTS.Write) {
            supervisorAccessRights[index].WriteAccess = nAccessRight;
        } else if (accessRightType === ACCESSRIGHTS.Delete) {
            supervisorAccessRights[index].DeleteAccess = nAccessRight;
        } else if (accessRightType === ACCESSRIGHTS.Import) {
            supervisorAccessRights[index].ImportAccess = nAccessRight;
        } else if (accessRightType === ACCESSRIGHTS.Export) {
            supervisorAccessRights[index].ExportAccess = nAccessRight;
        } else if (accessRightType === ACCESSRIGHTS.Verify) {
            supervisorAccessRights[index].VerifyAccess = nAccessRight;
        } else if (accessRightType === ACCESSRIGHTS.Approve) {
            supervisorAccessRights[index].ApprovalAccess = nAccessRight;
        }
        supervisorAccessRights[index].IsModified = true;
        setChangeStatus(!changeStatus);
    };

    const selectAllAccessRights = (e, accessRightType) => {
        if (supervisorAccessRights.length <= 0) return;

        let isChecked = e.target.checked;
        let index = 0;
        for (index = 0; index < supervisorAccessRights.length; index++) {
            if (accessRightType === ACCESSRIGHTS.Read) {
                if (supervisorAccessRights[index].ReadAccess === 0) {
                    continue;
                } else {
                    supervisorAccessRights[index].ReadAccess = isChecked ? 2 : 1;
                }
            } else if (accessRightType === ACCESSRIGHTS.Write) {
                if (supervisorAccessRights[index].WriteAccess === 0) {
                    continue;
                } else {
                    supervisorAccessRights[index].WriteAccess = isChecked ? 2 : 1;
                }
            } else if (accessRightType === ACCESSRIGHTS.Delete) {
                if (supervisorAccessRights[index].DeleteAccess === 0) {
                    continue;
                } else {
                    supervisorAccessRights[index].DeleteAccess = isChecked ? 2 : 1;
                }
            } else if (accessRightType === ACCESSRIGHTS.Import) {
                if (supervisorAccessRights[index].ImportAccess === 0) {
                    continue;
                } else {
                    supervisorAccessRights[index].ImportAccess = isChecked ? 2 : 1;
                }
            } else if (accessRightType === ACCESSRIGHTS.Export) {
                if (supervisorAccessRights[index].ExportAccess === 0) {
                    continue;
                } else {
                    supervisorAccessRights[index].ExportAccess = isChecked ? 2 : 1;
                }
            } else if (accessRightType === ACCESSRIGHTS.Verify) {
                if (supervisorAccessRights[index].VerifyAccess === 0) {
                    continue;
                } else {
                    supervisorAccessRights[index].VerifyAccess = isChecked ? 2 : 1;
                }
            } else if (accessRightType === ACCESSRIGHTS.Approve) {
                if (supervisorAccessRights[index].ApprovalAccess === 0) {
                    continue;
                } else {
                    supervisorAccessRights[index].ApprovalAccess = isChecked ? 2 : 1;
                }
            }
            supervisorAccessRights[index].IsModified = true;
        }

        if (accessRightType === ACCESSRIGHTS.Read) {
            setIsReadAllAccess(isChecked);
        } else if (accessRightType === ACCESSRIGHTS.Write) {
            setIsWriteAllAccess(isChecked);
        } else if (accessRightType === ACCESSRIGHTS.Delete) {
            setIsDeleteAllAccess(isChecked);
        } else if (accessRightType === ACCESSRIGHTS.Import) {
            setIsImportAllAccess(isChecked);
        } else if (accessRightType === ACCESSRIGHTS.Export) {
            setIsExportAllAccess(isChecked);
        } else if (accessRightType === ACCESSRIGHTS.Verify) {
            setIsVerifyAllAccess(isChecked);
        } else if (accessRightType === ACCESSRIGHTS.Approve) {
            setIsApproveAllAccess(isChecked);
        }
        setChangeStatus(!changeStatus);
    };

    const updateAccessRights = async () => {
        let index = 0;
        let modifiedAccessRights = [];
        for (index = 0; index < supervisorAccessRights.length; index++) {
            if (supervisorAccessRights[index].IsModified) {
                modifiedAccessRights.push(supervisorAccessRights[index]);
            }
        }

        if (modifiedAccessRights.length === 0) {
            alert(getMultiLanguageMessage('msg_NoChangesMade_Error', language));
            return;
        }

        if (window.confirm(getMultiLanguageMessage('msg_Update_Confirm', language))) {
            setIsButtonClicked(true);
            const params = {
                VfaspID: process.env.REACT_APP_VFASP_CODE,
                AdminID: localStorage.getItem("supervisorid"),
                AccessRightList: modifiedAccessRights
            };
            await client(localStorage.getItem("supervisortoken")).put(`${BASE_URL}/accessrights/update`, params).then((response) => {
                setIsSubmitSuccess(true);
            }).catch(error => {
                alert(getMultiLanguageMessage('msg_Server_Error', language));
                setIsSubmitSuccess(false);
            });

            setAdminAccessRights([]);
            props.actionGetSupervisorAccessRights({ SearchAdminID: selectedAdmin.AdminID });
            setIsButtonClicked(false);
        }
    };

    useEffect(() => {
        if (props?.supervisorAccessRights?.length > 0) {
            setAdminAccessRights(props.supervisorAccessRights);
            let index = 0;
            let isReadAllSelected = true;
            let isWriteAllSelected = true;
            let isDeleteAllSelected = true;
            let isImportAllSelected = true;
            let isExportAllSelected = true;
            let isVerifyAllSelected = true;
            let isApproveAllSelected = true;
            for (index = 0; index < props.supervisorAccessRights.length; index++) {
                if (props.supervisorAccessRights[index].ReadAccess === 1) {
                    isReadAllSelected = false;
                }
                if (props.supervisorAccessRights[index].WriteAccess === 1) {
                    isWriteAllSelected = false;
                }
                if (props.supervisorAccessRights[index].DeleteAccess === 1) {
                    isDeleteAllSelected = false;
                }
                if (props.supervisorAccessRights[index].ImportAccess === 1) {
                    isImportAllSelected = false;
                }
                if (props.supervisorAccessRights[index].ExportAccess === 1) {
                    isExportAllSelected = false;
                }
                if (props.supervisorAccessRights[index].VerifyAccess === 1) {
                    isVerifyAllSelected = false;
                }
                if (props.supervisorAccessRights[index].ApprovalAccess === 1) {
                    isApproveAllSelected = false;
                }
            }
            setIsReadAllAccess(isReadAllSelected);
            setIsWriteAllAccess(isWriteAllSelected);
            setIsDeleteAllAccess(isDeleteAllSelected);
            setIsImportAllAccess(isImportAllSelected);
            setIsExportAllAccess(isExportAllSelected);
            setIsVerifyAllAccess(isVerifyAllSelected);
            setIsApproveAllAccess(isApproveAllSelected);
            setIsButtonClicked(false);
        }
    }, [props.supervisorAccessRights]);

    useEffect(() => {
        if (props?.supervisorList?.length > 0) {
            setSupervisorList(props.supervisorList);
        }
        setIsButtonClicked(false);
    }, [props.supervisorList]);

    useEffect(() => {
        if (props?.supervisor?.length > 0) {
        }
    }, [props.supervisor]);

    useEffect(() => {
        let selectedLanguage = localStorage.getItem("locale");
        setLanguage(selectedLanguage);
        let accessRights = getAccessRightsForPageID(PAGEID.AdminAccessRights);
        setPageAccessRights(accessRights);
        if (accessRights && accessRights.ReadAccess === ACCESSRIGHTSTYPE.Yes) {
        } else {
            alert(getMultiLanguageMessage('Msg_InvalidAccessRights', selectedLanguage));
        }
    }, []);

    return ((props?.supervisor?.length > 0 && pageAccessRights && pageAccessRights.ReadAccess === ACCESSRIGHTSTYPE.Yes)) ? (
        <div className="user-panel">
            <h2 className="user-panel-title">{translate('Menu-SupervisorAccessRights')}</h2>

            <Select id="search-field" name="search-field" value={searchField} label={translate('SearchField')} onChange={handleChange} sx={{ height: 38, width: 230 }}>
                <MenuItem value={0}><em>{translate('Select-SearchField')}</em></MenuItem>
                <MenuItem value={1}>{translate('AdminID')}</MenuItem>
                <MenuItem value={2}>{translate('MailID')}</MenuItem>
                <MenuItem value={3}>{translate('AdminName')}</MenuItem>
            </Select>

            &nbsp;&nbsp;<TextField id="search-keyword" name="search-keyword" value={searchKeyword} label={translate('SearchKeyword')} variant="outlined" size="small" onChange={handleChange} sx={{ height: 38, width: 300 }} />
            &nbsp;&nbsp;<Button variant="contained" onClick={() => onClickSearch()}>{translate('btnSearch')}</Button>
            &nbsp;<Button variant="contained" onClick={() => onClickClear()}>{translate('btnClear')}</Button>
            <div className="gaps-1x" />

            {(pageId === 0) &&
                <table className="adminTable" style={{ width: 890 }}>
                    <tbody>
                        <tr className="adminTR">
                            <th className="adminTH" style={{ width: '29%' }}>{translate('AdminID')}</th>
                            <th className="adminTH" style={{ width: '23%' }}>{translate('MailID')}</th>
                            <th className="adminTH" style={{ width: '20%' }}>{translate('AdminName')}</th>
                            <th className="adminTH" style={{ width: '10%' }}>{translate('Status')}</th>
                            <th className="adminTH" style={{ width: '18%' }}>{translate('CreatedDate')}</th>
                        </tr>
                        {supervisorList?.map((supervisor, index) => {
                            return <tr className="adminTR" key={supervisor.AUTORECID}>
                                <td className="adminTD" width='29%' align='center'><a href='#' onClick={event => goToAdminAcessRights(index)}>{supervisor.AdminID}</a></td>
                                <td className="adminTD" width='23%' align='left'>{supervisor.MailID}</td>
                                <td className="adminTD" width='20%' align='left'>{supervisor.FirstName + ' ' + supervisor.LastName}</td>
                                <td className="adminTD" width='10%' align='center'>{supervisor.AdminStatus}</td>
                                <td className="adminTD" width='18%' align='center'>{supervisor.DateCreated}</td>
                            </tr>
                        })
                        }
                    </tbody>
                </table>
            }

            {/* Access Rights Table */}
            {(pageId === 1) &&
                <div className="tab-content" id="security-opt-tab">
                    {/* Selected Admin Table */}
                    <table className="adminTable" style={{ width: 350 }}>
                        <tbody>
                            <tr className="adminTR" key={'keyAdminID'}>
                                <td className="adminTD" width='30%' align='left'>{translate('AdminID')}</td>
                                <td className="adminTD" width='70%' align='left'>{selectedAdmin.AdminID}</td>
                            </tr>
                            <tr className="adminTR" key={'keyAdminName'}>
                                <td className="adminTD" width='30%' align='left'>{translate('AdminName')}</td>
                                <td className="adminTD" width='70%' align='left'>{selectedAdmin.FirstName + ' ' + selectedAdmin.LastName}</td>
                            </tr>
                        </tbody>
                    </table>

                    <div className="gaps-1x" />
                    <div className="tab-pane active show" id="password-opt">
                        <form action="#">
                            {/* Access Rights Table */}
                            <table className="adminTable" width='100%'>
                                <tbody>
                                    <tr className="adminTR">
                                        <th className="adminTH" style={{ width: '30%' }}>{translate('PageName')}</th>
                                        <th className="adminTH" style={{ width: '10%' }}>{translate('ReadAccess')}</th>
                                        <th className="adminTH" style={{ width: '10%' }}>{translate('WriteAccess')}</th>
                                        <th className="adminTH" style={{ width: '10%' }}>{translate('DeleteAccess')}</th>
                                        <th className="adminTH" style={{ width: '10%' }}>{translate('ImportAccess')}</th>
                                        <th className="adminTH" style={{ width: '10%' }}>{translate('ExportAccess')}</th>
                                        <th className="adminTH" style={{ width: '10%' }}>{translate('VerifyAccess')}</th>
                                        <th className="adminTH" style={{ width: '10%' }}>{translate('ApprovalAccess')}</th>
                                    </tr>
                                    {(supervisorAccessRights?.length > 0) &&
                                        <tr className="adminTR" key={'chkSelectAll'}>
                                            <td className="adminTD" width='30%' align='center'></td>
                                            <td className="adminTD" width='10%' align='center'>
                                                <Checkbox checked={isReadAllAccess} onChange={event => selectAllAccessRights(event, ACCESSRIGHTS.Read)} name={"id_ReadAccessAll"} id={"id_ReadAccessAll"} />{translate('SelectAll')}
                                            </td>
                                            <td className="adminTD" width='10%' align='center'>
                                                <Checkbox checked={isWriteAllAccess} onChange={event => selectAllAccessRights(event, ACCESSRIGHTS.Write)} name={"id_WriteAccessAll"} id={"id_WriteAccessAll"} />{translate('SelectAll')}
                                            </td>
                                            <td className="adminTD" width='10%' align='center'>
                                                <Checkbox checked={isDeleteAllAccess} onChange={event => selectAllAccessRights(event, ACCESSRIGHTS.Delete)} name={"id_DeleteAccessAll"} id={"id_DeleteAccessAll"} />{translate('SelectAll')}
                                            </td>
                                            <td className="adminTD" width='10%' align='center'>
                                                <Checkbox checked={isImportAllAccess} onChange={event => selectAllAccessRights(event, ACCESSRIGHTS.Import)} name={"id_ImportAccessAll"} id={"id_ImportAccessAll"} />{translate('SelectAll')}
                                            </td>
                                            <td className="adminTD" width='10%' align='center'>
                                                <Checkbox checked={isExportAllAccess} onChange={event => selectAllAccessRights(event, ACCESSRIGHTS.Export)} name={"id_ExportAccessAll"} id={"id_ExportAccessAll"} />{translate('SelectAll')}
                                            </td>
                                            <td className="adminTD" width='10%' align='center'>
                                                <Checkbox checked={isVerifyAllAccess} onChange={event => selectAllAccessRights(event, ACCESSRIGHTS.Verify)} name={"id_VerifyAccessAll"} id={"id_VerifyAccessAll"} />{translate('SelectAll')}
                                            </td>
                                            <td className="adminTD" width='10%' align='center'>
                                                <Checkbox checked={isApproveAllAccess} onChange={event => selectAllAccessRights(event, ACCESSRIGHTS.Approve)} name={"id_ApprovalAccessAll"} id={"id_ApprovalAccessAll"} />{translate('SelectAll')}
                                            </td>
                                        </tr>
                                    }
                                    {supervisorAccessRights?.map((accessRight, index) => {
                                        let sPageLabel = '' + PAGELABEL[accessRight.PageID] + '';
                                        return <tr className="adminTR" key={accessRight.AUTORECID}>
                                            <td className='adminTD' width='30%' align='left'>{translate(sPageLabel)}</td>
                                            <td className='adminTD' width='10%' align='center'>
                                                {(accessRight.ReadAccess > 0) &&
                                                    <Checkbox checked={(accessRight.ReadAccess === 2) ? true : false} onChange={event => handleAccessRightsChange(event, index, ACCESSRIGHTS.Read)} name={"id_ReadAccess_" + accessRight.AUTORECID} id={"id_ReadAccess_" + accessRight.AUTORECID} />
                                                }
                                            </td>
                                            <td className='adminTD' width='10%' align='center'>
                                                {(accessRight.WriteAccess > 0) &&
                                                    <Checkbox checked={(accessRight.WriteAccess === 2) ? true : false} onChange={event => handleAccessRightsChange(event, index, ACCESSRIGHTS.Write)} name={"id_WriteAccess_" + accessRight.AUTORECID} id={"id_WriteAccess_" + accessRight.AUTORECID} />
                                                }
                                            </td>
                                            <td className='adminTD' width='10%' align='center'>
                                                {(accessRight.DeleteAccess > 0) &&
                                                    <Checkbox checked={(accessRight.DeleteAccess === 2) ? true : false} onChange={event => handleAccessRightsChange(event, index, ACCESSRIGHTS.Delete)} name={"id_DeleteAccess_" + accessRight.AUTORECID} id={"id_DeleteAccess_" + accessRight.AUTORECID} />
                                                }
                                            </td>
                                            <td className='adminTD' width='10%' align='center'>
                                                {(accessRight.ImportAccess > 0) &&
                                                    <Checkbox checked={(accessRight.ImportAccess === 2) ? true : false} onChange={event => handleAccessRightsChange(event, index, ACCESSRIGHTS.Import)} name={"id_ImportAccess_" + accessRight.AUTORECID} id={"id_ImportAccess_" + accessRight.AUTORECID} />
                                                }
                                            </td>
                                            <td className='adminTD' width='10%' align='center'>
                                                {(accessRight.ExportAccess > 0) &&
                                                    <Checkbox checked={(accessRight.ExportAccess === 2) ? true : false} onChange={event => handleAccessRightsChange(event, index, ACCESSRIGHTS.Export)} name={"id_ExportAccess_" + accessRight.AUTORECID} id={"id_ExportAccess_" + accessRight.AUTORECID} />
                                                }
                                            </td>
                                            <td className='adminTD' width='10%' align='center'>
                                                <Checkbox checked={(accessRight.VerifyAccess === 2) ? true : false} onChange={event => handleAccessRightsChange(event, index, ACCESSRIGHTS.Verify)} name={"id_VerifyAccess_" + accessRight.AUTORECID} id={"id_VerifyAccess_" + accessRight.AUTORECID} />
                                            </td>
                                            <td className='adminTD' width='10%' align='center'>
                                                <Checkbox checked={(accessRight.ApprovalAccess === 2) ? true : false} onChange={event => handleAccessRightsChange(event, index, ACCESSRIGHTS.Approve)} name={"id_ApprovalAccess_" + accessRight.AUTORECID} id={"id_ApprovalAccess_" + accessRight.AUTORECID} />
                                            </td>
                                        </tr>
                                    })}
                                </tbody>
                            </table>

                            {isButtonClicked &&
                                <>
                                    <div className="gaps" />
                                    <img width={80} src={require('../assets/images/loading.gif')} srcSet={require('../assets/images/loading.gif')} alt="loading" />
                                </>
                            }
                            <div className="gaps-2x" />
                            <div className="d-sm-flex justify-content-between align-items-center">
                                <div className="gaps-2x d-sm-none" />
                                <span className="color-success">
                                    {isSubmitSuccess &&
                                        <div>
                                            <em className="ti ti-check-box" /> {translate('Update-Success-Message')}
                                            <div className="gaps-1x" />
                                        </div>
                                    }
                                </span>
                            </div>

                            {pageAccessRights.WriteAccess === ACCESSRIGHTSTYPE.Yes &&
                                <div className="d-sm-flex justify-content-between align-items-center">
                                    <Button variant="contained" size='large' disabled={isButtonClicked ? true : false} onClick={() => updateAccessRights()}>{translate('btnUpdate')}</Button>
                                    <div className="gaps-2x d-sm-none" />
                                </div>
                            }
                        </form>
                        {/* form */}
                    </div>
                    {/* .tab-pane */}
                </div>
            }
        </div>
    ) : '';
};

const mapStateToProps = state => {
    return {
        navBar: state.siteLayout.navBar,
        supervisor: state.remote.supervisor,
        supervisorList: state.remote.supervisorList,
        supervisorAccessRights: state.remote.supervisorAccessRightList
    };
};

export default connect(mapStateToProps, {
    actionToggleNavBar,
    actionToggleSideBar,
    actionToggleFooter,
    actionGetSupervisorListForAccessRights,
    actionGetSupervisorAccessRights
})(SupervisorAccessRights);
